export default __webpack_public_path__ + "static/icon-71258d37632d44e43fcca6b3ef6d67cd.png";